export default "__VITE_ASSET__fa686c89__"